import React, { useEffect, useState, useCallback } from "react";
import LogsTable from "../AssetLogs/Logs.table"; // adjust the path if needed
import { getAssetDocumentFileHistory } from "../../service/api";

const TrancheDocumentLogs = ({ trancheId, colId }) => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const itemsPerPage = 10;

  const fetchTrancheDocumentHistory = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getAssetDocumentFileHistory({
        trancheId,
        colId,
        page: currentPage,
        limit: itemsPerPage,
      });

      if (response?.success && response?.data) {
        const formatted = response.data.data.map((item) => {
          const newData = item.changeData?.new || {};
          return {
            _id: item._id,
            fileName: newData.fileName,
            uniqueId: newData.uniqueId,
            aiValidated: newData.aiValidated ? "Yes" : "No",
            manualValidated: newData.manualValidated ? "Yes" : "No",
            fileLink: newData.fileUrl,
            createdAt: new Date(item.createdAt).toISOString().split("T")[0],
            status: item.status,
            changeType: item.changeType,
            user: item?.createdBy?.name ?? item?.createdFrom,
          };
        });

        setRows(formatted);
        setTotalDocs(response.data.totalDocs || 0);
      }
    } catch (error) {
      console.error("Error fetching tranche document history:", error);
    } finally {
      setIsLoading(false);
    }
  }, [trancheId, colId, currentPage, itemsPerPage]);

  useEffect(() => {
    if (trancheId && colId) {
      fetchTrancheDocumentHistory();
    }
  }, [trancheId, colId, currentPage, fetchTrancheDocumentHistory]);

  const columns = [
    { id: "user", label: "User" },
    { id: "changeType", label: "Change Type" },
    { id: "status", label: "Status" },
    { id: "fileName", label: "File Name" },
    { id: "fileLink", label: "File Link" },
    { id: "uniqueId", label: "Unique ID" },
    { id: "aiValidated", label: "AI Validated" },
    { id: "manualValidated", label: "Manual Validated" },
    { id: "createdAt", label: "Created At" },
  ];

  return (
    <div>
      <LogsTable
        isLoading={isLoading}
        columns={columns}
        rows={rows}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalDocs={totalDocs}
        itemsPerPage={itemsPerPage}
      />
    </div>
  );
};

export default TrancheDocumentLogs;
